import {createApiClient} from "./index";
import {EmailLogsDto, EmailLogsQueryParams} from "types/emailLogs";
import {generateQueryParams} from "helpers/common";
import {ApiEnvType} from "types/filterContext";

export const emailLogsApi = {
    async getEmailLogs({
                           filters,
                           token,
                           params,
                           apiKey = 'dev-us'
                       }: EmailLogsQueryParams, signal?: AbortSignal): Promise<EmailLogsDto> {
        const api = createApiClient(apiKey as ApiEnvType);

        const data = Object.fromEntries(
            Object.entries(filters).filter(([_, value]) => !!value || value === 0)
        );

        const queryParams = generateQueryParams(params);

        const response = await api.post(`/email-logs/filter${queryParams}`, {
            ...data,

        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            signal,
        });
        return response.data;
    },
};
